export enum EcoManageProductsByEnum {
  WEB_SHOP = 'WEB_SHOP',
  RUNPLE = 'RUNPLE',
}
